import api from '../../../App/socket';

export const sendEmailRequest = (template_id, lead_id) => (
    api.send({
        api: 'module',
        module: 'Leads',
        classMethod: 'SendEmail',
        options: {
            where: {
                template_id, lead_id,
            },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/send_email_request.js